import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CustomFormComponent } from '@bo-client/activation-management/custom-form.component';
import { CreateGridRegistrationFormsService } from '@bo-client/activation-management/grid-registration/create-grid-registration-forms.service';
import { GridRegistrationModel } from '@bo-client/activation-management/grid-registration/model/grid-registration.model';
import { DataForCustomFormModel } from '@bo-client/activation-management/shared/models/actionWithMoreInfo.model';

@Component({
  selector: 'app-gr-mastr-numbers',
  templateUrl: './gr-mastr-numbers.component.html',
  styleUrls: ['./gr-mastr-numbers.component.scss']
})
export class GrMastrNumbersComponent
  implements OnInit, CustomFormComponent<GridRegistrationModel, GridRegistrationModel>
{
  @Input() data: DataForCustomFormModel<GridRegistrationModel>;
  @Output() onConfirm: EventEmitter<GridRegistrationModel> = new EventEmitter();

  model: GridRegistrationModel;

  currentForm: FormGroup;

  constructor(private createFormsGridRegistrationService: CreateGridRegistrationFormsService) {}

  ngOnInit(): void {
    this.model = this.data.model;
    this.currentForm = this.createFormsGridRegistrationService.createMaStNumbersForm(this.data.model);
  }

  cancel() {
    this.onConfirm.emit(null);
  }

  confirm() {
    if (this.currentForm.valid) {
      this.model.maStRNumber = this.currentForm.get('maStRNumber').value;
      this.model.maStRNumberProducer = this.currentForm.get('maStRNumberProducer').value;
      this.model.maStRNumberStorage = this.currentForm.get('maStRNumberStorage').value;
      this.model.maStRRegistrationDate = this.currentForm.get('maStRRegistrationDate').value;
      this.onConfirm.emit(this.model);
    } else {
      this.currentForm.markAllAsTouched();
    }
  }
}
